@solidale.controller 'LocShowCtrl', ['$rootScope', '$scope', '$stateParams', '$state', '$mdDialog', 'Location', '$timeout', 'uiGmapGoogleMapApi', 'uiGmapIsReady', 'Locrequest', ($rootScope, $scope, $stateParams, $state, $mdDialog, Location, $timeout, uiGmapGoogleMapApi, uiGmapIsReady, Locrequest) ->

	$location_id = $stateParams.locid
	$scope.showPhoto = false
	$scope.isApplied = false
	
	$getLocation = () ->
		
		Location.query({ locid: $location_id}).then (resp) ->
			$scope.location = resp.data
			
			# Btn status
			if $scope.location.requests.length > 0
				angular.forEach $scope.location.requests, (v, k) ->
					if v.uid == $rootScope.user.uid && v.p2_done != 'true'
						$scope.isApplied = true
						$scope.appliedId = v.req_id

		$timeout ()->
			$scope.showPhoto = true
		, 1000

	$createMarker = ()->
		$scope.locationMarker = 
			id: 56
			coords:
				latitude: $scope.location.lat
				longitude: $scope.location.lng
			options:
				zIndex: 10
				icon: '/image/icon-home.png'

		$scope.locationMap = 
			center:
				latitude: $scope.location.lat
				longitude: $scope.location.lng


	# ====================
	# Windows
	# =====================			
	$scope.openPhotoWindow = () ->
		$mdDialog.show(
			controller: 'ImageShowWindowCtrl'
			clickOutsideToClose: true
			templateUrl: 'views/window/imageshowwindow.html'
			locals:
				roomphotos: $scope.location.available_roomphotos
				
		).then ()->
			console.log data

		, ()->
			console.log 'close'


	$scope.openRoomWindow = (ind) ->
		$mdDialog.show(
			controller: 'RoomShowWindowCtrl'
			clickOutsideToClose: true
			templateUrl: 'views/window/roomshowwindow.html'
			locals:
				curIndex: ind
				rooms: $scope.location.available_rooms
				
		).then ()->
			console.log 'close'

		, ()->
			console.log 'close'
				

	# ================
	# Gmaps 
	# ==================
	$rootScope.openLoading()	
	uiGmapGoogleMapApi.then (maps) ->
		$scope.locationMap = 
			center:
				latitude: 35.0060799
				longitude: 135.7259288
			zoom: 14
			options:
				scrollwheel: false
				mapTypeControl: false
			control: {}


		uiGmapIsReady.promise().then () ->
			$getLocation().then () ->
				$createMarker()
				$rootScope.closeLoading()
					

	# ================
	# Send Request
	# ================
	$scope.sendRequest = ()->
		$rootScope.openLoading()

		$obj = 
			uid: $rootScope.user.uid
			req_id: Math.random().toString(36).substr(2, 10)
			location_id: $location_id
			p1_isprofile: false
			p1_done: false
			p1_result: false
			p1_comment: '無し'
			p2_isprofile: false
			p2_done: false
			p2_result: false
			p2_comment: '無し'

		Locrequest.new($obj).then (resp)->
			$scope.isApplied = true

			$timeout ()->
				$rootScope.closeLoading()
				$state.go('locRequest')
			, 1000
				
		, ()->
			$timeout ()->
				$rootScope.closeLoading()
			, 1000


]